// extracted by mini-css-extract-plugin
export default {"fallback":"errorBoundary_fallback__TZd9H","title":"errorBoundary_title__DdKGe","detail":"errorBoundary_detail__Vl7-P","retry":"errorBoundary_retry__dYMFr"};